'use client';

import { useRouter } from 'next/navigation';
import { useQueryState } from 'nuqs';

import { AppBar, ErrorNotice } from '~/components';
import { SearchForm } from '~/app/search/_components';

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ reset }: Props) {
  const router = useRouter();
  const [q] = useQueryState('q');

  return (
    <>
      <AppBar slot={<SearchForm value={q ?? ''} onFocus={() => router.push(`/search?q=${q}`)} />} />
      <ErrorNotice
        onResetClick={() => {
          reset();
        }}
      />
    </>
  );
}
